import { getCashinClosingDialogState } from 'nike-ui/src/components/ticketus/cashin/cashin-utils';
import { useReframe } from 'nike-re-framejs';
import { useRef } from 'react';
import { activeTransaction$$, cashinOfferByTicketId$$ } from 'nike-ui/src/components/turboLive/components/cashin/subs';

export const useCashinClosingDialog = ticketId => {
    const { subscribe } = useReframe();

    const offer = subscribe(cashinOfferByTicketId$$(ticketId));
    const transaction = subscribe(activeTransaction$$(ticketId));
    const ref = useRef(null);
    const state = getCashinClosingDialogState({
        cashinOffer: offer,
        cashinTransaction: transaction
    });

    return {
        offer,
        state,
        ref
    };
};
